export default __webpack_public_path__ + "static/media/image3.244ab3a4.jpg";